import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/board-project-preview';
import moment from 'moment';

Component('tr-board-project-preview-board', {
  properties: {
    firstTodoName: String,
    secondTodoName: String,
    thirdTodoName: String,
    firstListName: String,
    secondListName: String,
    thirdListName: String,
    animojiAvatars: Array,
    firstTodoStartAndDueAt: Array,
    secondTodoStartAndDueAt: Array,
    thirdTodoStartAndDueAt: Array,
  },

  mixins: [eventListenerMixin],

  connected() {
    const [firstTodo, secondTodo, thirdTodo] = this.querySelectorAll('.board-project-preview-todo-card');
    Object.assign(this, { firstTodo, secondTodo, thirdTodo });
    const [firstList, secondList, thirdList] = this.querySelectorAll('.board-project-preview-column');
    Object.assign(this, { firstList, secondList, thirdList });
  },
  disconnected() {
    this.stopListening();
  },

  updateTodoName(todo, name) {
    const targetTodoName = `${todo}Name`;
    if (name && name.length > 0) {
      const formatDueAt = d => moment(d).format('MMMDo');
      const dueAt = [this.firstTodoStartAndDueAt.map(formatDueAt).join(' - '),
        this.secondTodoStartAndDueAt.map(formatDueAt).join(' - '),
        this.thirdTodoStartAndDueAt.map(formatDueAt).join(' - ')][this.todoSequence(todo)];
      const assignee = this.animojiAvatars[this.todoSequence(todo)];
      const priority = ['high', 'medium', 'low'][this.todoSequence(todo)];
      this[todo].innerHTML = this.renderTodoCardInnerHTML(name, dueAt, assignee);
      this[todo].setAttribute('priority', priority);
    } else {
      this[todo].innerHTML = this.renderTodoCardPlaceholderInnerHTML();
    }
    this[targetTodoName] = name;
  },

  updateListName(list, name) {
    const targetListName = `${list}Name`;
    this[list].querySelector('.board-project-preview-header').innerHTML = name;
    this[targetListName] = name;
  },

  todoSequence(todo) {
    return {
      firstTodo: 0,
      secondTodo: 1,
      thirdTodo: 2,
    }[todo];
  },

  renderTodoCardInnerHTML(name, dueAt, assignee) {
    return `
    <div class="board-project-preview-todo-name-container">
      <div class="board-project-preview-todo-name">${name}</div>
    </div>
    <div class="board-project-preview-todo-due-at-and-assignee">
      <div class="board-project-preview-todo-due-at">${dueAt}</div>
      <img class="board-project-preview-todo-assignee" src="https://towerfiles.oss-cn-hangzhou.aliyuncs.com/animoji/${assignee}.png" alt="${assignee}">
    </div>
    `.trim();
  },

  renderTodoCardPlaceholderInnerHTML() {
    return `
    <div class="board-project-preview-todo-name-container">
      <div class="board-project-preview-todo-placeholder board-project-preview-todo-name-placeholder"></div>
    </div>
    <div class="board-project-preview-todo-due-at-and-assignee">
      <div class="board-project-preview-todo-placeholder board-project-preview-todo-due-at-placeholder"></div>
      <div class="board-project-preview-todo-assignee placeholder"></div>
    </div>
    `.trim();
  },
});
